"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Actions = require("./actions");
var Getters = require("./getters");
var Mutations = require("./mutations");
var state_1 = require("./state");
var CampaignsTeaser = (function () {
    function CampaignsTeaser(config, plugins) {
        if (plugins === void 0) { plugins = []; }
        this.namespaced = true;
        this.mutations = Mutations;
        this.getters = Getters;
        this.actions = Actions;
        this.state = new state_1.State(config);
        this.plugins = plugins;
    }
    return CampaignsTeaser;
}());
exports.CampaignsTeaser = CampaignsTeaser;
//# sourceMappingURL=index.js.map